import React from "react";
import { SITE } from "../content/site";

export default function PrivacyPolicy() {
  const year = new Date().getFullYear();

  return (
    <article className="dp-prose">
      <p className="dp-eyebrow">Legal</p>
      <h1>Privacy Policy</h1>
      <p className="dp-prose__meta">Last updated: 3 April {year}</p>

      <p>
        {SITE.legalName} ("us", "we", or "our") operates the Digital Philosophy
        website (the "Service"). This page informs you of our policies regarding
        the collection, use, and disclosure of personal data when you use our
        Service, and the choices you have associated with that data.
      </p>

      <h2>Information collection and use</h2>
      <p>
        We collect several different types of information for various purposes to
        provide and improve our Service to you. We only retain what we need, and
        we do not sell your personal data.
      </p>

      <h2>Contact us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us:</p>
      <ul>
        <li>
          By email:{" "}
          <a href="mailto:privacy@digitalphilosophy.io">
            privacy@digitalphilosophy.io
          </a>
        </li>
        <li>By mail: {SITE.address}</li>
      </ul>
    </article>
  );
}
